function DecimalButton({ onClick }) {
  return <button onClick={() => onClick()} className="btn btn-block btn-secondary">.</button>;
}

export default DecimalButton;
